import { Outlet } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Box, CssBaseline } from '@mui/material'

const theme = createTheme({
  typography: {
    fontFamily: 'Work Sans, Arial, sans-serif',
  },
})

export default function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box>
        <Outlet />
      </Box>
    </ThemeProvider>
  )
}
